import type { ElinaProject } from './elina-contract';
import { type Locale } from '../i18n/core';
import { getTranslator } from '../i18n/catalog';

export interface ProposalCard { label?: string; title?: string; text: string; value?: string }
export interface ProposalSection { number: string; kind: 'solutions' | 'benefits' | 'next'; title: string; lead?: string; cards: ProposalCard[]; note?: string; columns: 1 | 2 | 3 }
export const PROPOSAL_NEXT_STEP = 'Validons les résultats à viser en premier. RDV-Partners précisera le périmètre et les modalités, puis vous remettra un devis.';
export const PROPOSAL_DISCLAIMER = 'Cette proposition ne comporte aucun prix et ne vaut pas engagement contractuel.';

/** Only project facts are reused for older snapshots; never invent business benefits. */
export function proposalAmbition(project: ElinaProject, locale: Locale = 'fr'): string {
  const t = getTranslator(locale);
  const ambition = project.ambition || project.primaryGoal || project.title;
  return /^(?:Votre ambition\b|Your ambition\b|Su ambición\b|Ваша цель|Ваши цели)/i.test(ambition) ? ambition : t('Votre ambition : {ambition}', { ambition: ambition || t('à préciser ensemble.') });
}

/** One client-facing structure for the screen, CRM summary, HTML and PDF. */
export function proposalSections(project: ElinaProject, locale: Locale = 'fr'): ProposalSection[] {
  const t = getTranslator(locale);
  const gains = project.businessBenefits ?? [];
  return [
    { number: '01', kind: 'solutions', title: t('Ce que la solution fera pour vous'), columns: 2, cards: project.solutions.length
      ? project.solutions.filter(s => s.status === 'retained').map(s => ({ title: s.title, text: s.description, value: s.value }))
      : project.benefits.map(s => ({ title: s.title, text: s.description })) },
    ...(gains.length ? [{ number: '02', kind: 'benefits' as const, title: t('Au-delà du gain de temps'), columns: 3 as const, cards: gains.map(b => ({ title: b.title, text: b.description })) }] : []),
    { number: gains.length ? '03' : '02', kind: 'next', title: t('Pour avancer'), columns: 1, cards: [{ text: t(PROPOSAL_NEXT_STEP) }], note: [...project.assumptions, t(PROPOSAL_DISCLAIMER)].join(' ') },
  ];
}

